export default "__VITE_ASSET__o5hfr4OX__"